// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { PageableResponse } from '@coa/app/core/model/response';
import { Client } from '../models/client';

export const clientsRequested = createAction('[AUTH] Clients Requested');
export const clientsRequestSucceeded = createAction('[AUTH] Clients Succeeded', props<{ clientsResponse: PageableResponse<Client> }>());
export const clientsRequestFailed = createAction('[AUTH] Clients Failed');
